import { TransferJourneyType } from './transfer.interfaces';

export const FLIGHT_BUFFER_DROP_OFF = 120;
export const FLIGHT_BUFFER_DROP_OFF_MINIMUM = 60;
export const FLIGHT_BUFFER_PICKUP = 60;
export const FLIGHT_BUFFER_PICKUP_MINIMUM = 30;

export const FERRY_BUFFER_DROP_OFF = 60;
export const FERRY_BUFFER_DROP_OFF_MINIMUM = 30;
export const FERRY_BUFFER_PICKUP = 30;
export const FERRY_BUFFER_PICKUP_MINIMUM = 15;

export const VEHICLE_DURATION_BUFFER = 60;

export const SUPPORTED_TRANSFER_TYPES: TransferJourneyType[] = [
    TransferJourneyType.FlightHotel,
    TransferJourneyType.HotelFlight,
    TransferJourneyType.HotelHotel,
    ...[TransferJourneyType.HotelAirport, TransferJourneyType.AirportHotel],
    ...[TransferJourneyType.ActivityAirport, TransferJourneyType.AirportActivity],
];
